import { FC, ReactElement, useEffect, useState } from 'react';
import { useLocation, useRoute } from 'wouter';
import path from 'path';
import { useGame } from '../../stores/game';

export const RedirectToBaseCamp: FC<{
  children?: ReactElement;
}> = props => {
  const [match, params] = useRoute<GameRouteParams>('/:gamePlayId/:rest*');
  const [, setLocation] = useLocation();

  const isStarted = useGame(({ isStarted }) => isStarted);
  const currentPhase = useGame(({ currentPhase }) => currentPhase);
  const shouldLocationChange = useGame(({ shouldLocationChange }) =>
    shouldLocationChange(params.rest)
  );
  const basecampLocation = useGame(({ basecampLocation }) =>
    basecampLocation()
  );

  const pathname = path.join('/', params.gamePlayId, basecampLocation);

  console.log('🏕️ [RedirectToBaseCamp] State:', {
    gamePlayId: params.gamePlayId,
    rest: params.rest,
    isStarted,
    currentPhase,
    shouldLocationChange,
    basecampLocation,
    pathname
  });

  useEffect(() => {
    console.log('🏕️ [RedirectToBaseCamp] useEffect triggered', {
      currentPhase,
      currentPath: params?.rest,
      shouldLocationChange,
      basecampLocation,
      pathname
    });

    if (params?.rest?.includes('conversation-report')) {
      console.log('🏕️ [RedirectToBaseCamp] Skipping - conversation-report');
      return;
    }

    if (params?.rest?.includes('is-not-started')) {
      console.log('🏕️ [RedirectToBaseCamp] Skipping - already on is-not-started');
      return;
    }

    if (params?.rest?.includes('not-in-game')) {
      console.log('🏕️ [RedirectToBaseCamp] Skipping - already on not-in-game');
      return;
    }

    if (!isStarted) {
      const notStartedPath = `/${params.gamePlayId}/is-not-started`;
      console.log('🚫 [RedirectToBaseCamp] Game not started, redirecting to:', notStartedPath);
      setLocation(notStartedPath);
      return;
    }

    if (shouldLocationChange) {
      console.log('🔀 [RedirectToBaseCamp] Should change location, redirecting to:', pathname);
      setLocation(pathname);
      return;
    }

    console.log('✅ [RedirectToBaseCamp] No redirect needed');
  }, [isStarted, params?.gamePlayId, pathname, shouldLocationChange, basecampLocation, currentPhase]);

  if (!match) {
    console.log('❌ [RedirectToBaseCamp] No match!');
    return <span>This component is not loaded under the correct path</span>;
  }
  
  console.log('✅ [RedirectToBaseCamp] Rendering children');
  return props.children;
};

type GameRouteParams = {
  gamePlayId: string;
  rest: string;
};
